import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyModule } from 'owa-bundling';

import { TxpCalendarFormWrapperProps } from './components/TxpCalendarFormWrapper';
import { TxpPeekWrapperProps } from './components/TxpPeekWrapper';
import { TxpProps } from './components/Txp';
import { TxpHeaderProps } from './components/TxpHeader';

import { CALENDAR_READFORM_LOCATION } from './helpers/TxpConstants';

import areAnyTXPEntitiesSupported from './utils/featureChecks/areAnyTXPEntitiesSupported';

import TailoredActionName from './store/schema/telemetry/TailoredActionName';
import TxpSource from './store/viewSchema/TxpSource';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Txp", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export const Txp = createLazyComponent(lazyModule, m => m.Txp);
export const TxpPeekWrapper = createLazyComponent(lazyModule, m => m.TxpPeekWrapper);
export const TxpCalendarFormWrapper = createLazyComponent(
    lazyModule,
    m => m.TxpCalendarFormWrapper
);
export const UserVoice = createLazyComponent(lazyModule, m => m.UserVoice);
export const TxpHeader = createLazyComponent(lazyModule, m => m.TxpHeader);

export {
    TxpProps,
    TxpPeekWrapperProps,
    TxpHeaderProps,
    TxpCalendarFormWrapperProps,
    TxpSource,
    areAnyTXPEntitiesSupported,
    CALENDAR_READFORM_LOCATION,
    TailoredActionName,
};
